import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '../lib/api';

export function Signup() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await api.post('/auth/signup', { name, email, password });
      navigate('/onboarding');
    } catch (err: any) {
      setError(err.response?.data?.error ?? 'Signup failed');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-base">
      <div className="card w-full max-w-[400px] p-6 sm:p-8 space-y-4 mx-4 text-center">
        <div className="inline-flex items-center gap-2 mb-1">
          <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center font-bold text-white">Cr</div>
          <div className="text-lg font-semibold tracking-tight">Cros<span className="text-secondary-400">ova</span></div>
        </div>
        <h1 className="text-lg font-semibold">We're not accepting signups yet</h1>
        <p className="text-sm text-white/40">Crosova is currently in private testing. Check back soon.</p>
        <Link to="/login" className="block text-sm text-primary-300 hover:underline">Already have an account? Log in</Link>
      </div>
    </div>
  );
}
